import React from 'react';

const Provision29Section = () => {
  return (
    <section className="py-24 px-6 bg-[#050B15] text-white" id="context">
      <div className="max-w-[960px] mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl font-extrabold mb-6">Provision 29 changed the question.</h2>
            <p className="text-lg text-gray-300 mb-8">
              Regulators are moving beyond the existence of controls. They now demand evidence of <span className="text-white font-bold underline decoration-[#FFD100]">whether controls actually work</span> on a continuous basis.
            </p>
            <ul className="space-y-4 mb-10">
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-[#22C55E]">check_circle</span>
                <span><span className="font-semibold">Traceability:</span> Direct link from policy to proof.</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-[#FFD100]">verified</span>
                <span><span className="font-semibold">Confidence:</span> Continuous oversight, not just point-in-time.</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-[#F87171]">visibility</span>
                <span><span className="font-semibold">Visibility:</span> Clear reporting for CFO and Audit Committee.</span>
              </li>
            </ul>
            <p className="text-xl font-bold text-[#FFD100] italic">Spreadsheets were never designed for this.</p>
          </div>
          <div className="bg-white/5 p-8 rounded-2xl border border-white/10">
            <div className="text-6xl font-bold text-[#F87171] mb-4">29</div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-bold mb-2">UK Corporate Governance Code</p>
            <p className="text-lg text-gray-200">The Board should monitor the company's risk management and internal control systems and, at least annually, carry out a review of their effectiveness.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Provision29Section;
